import { alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function Button(theme) {
  return {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: theme.shape.borderRadius * 2.2,
          paddingLeft: theme.spacing(2.2),
          paddingRight: theme.spacing(2.2),
          transition: 'all 180ms ease',
          '&:hover': {
            boxShadow: theme.customShadows.z8,
          },
          '&:active': { transform: 'translateY(0.5px)' },
          '&.Mui-focusVisible': {
            boxShadow: `0 0 0 3px ${alpha(theme.palette.primary.main, 0.24)}`,
          },
        },
        sizeLarge: {
          height: 44,
        },
        containedInherit: {
          color: theme.palette.grey[800],
          boxShadow: 'none',
          '&:hover': {
            backgroundColor: theme.palette.grey[300],
          },
        },
        containedPrimary: {
          backgroundImage: `linear-gradient(180deg, ${alpha(theme.palette.primary.light, 0.2)} 0%, ${alpha(theme.palette.primary.dark, 0.2)} 100%)`,
          boxShadow: theme.customShadows.primary,
          '&:hover': {
            boxShadow: theme.customShadows.z12,
          },
        },
        containedSecondary: {
          boxShadow: theme.customShadows.secondary,
        },
        outlinedInherit: {
          border: `1px solid ${alpha(theme.palette.grey[500], 0.32)}`,
          '&:hover': {
            backgroundColor: theme.palette.action.hover,
          },
        },
        textInherit: {
          '&:hover': {
            backgroundColor: theme.palette.action.hover,
          },
        },
      },
    },
  };
}
